<template>
  <div class="flex flex-wrap gap-3">
    <OurInput
      v-model="sku"
      class="min-w-[16rem] flex-1"
      :label="$t('promotions.products.productCode')"
      :placeholder="$t('promotions.products.skuPlaceholder')"
      :error="error"
      @keyup.enter="onClickAdd"
    />

    <OurButton :text="$t('promotions.products.add')" :disabled="!sku.trim()" @click="onClickAdd" />
  </div>
</template>

<script>
export default {
  name: "AddProductsBySkuTab",

  data() {
    return {
      sku: "",
      error: "",
    };
  },

  methods: {
    onClickAdd() {
      const value = this.sku.trim();

      if (!value) {
        this.error = this.$t("validation.required");

        return;
      }

      this.error = "";
      this.$emit("add-sku", value);
      this.sku = "";
    },

    setError(message) {
      this.error = message;
    },
  },
};
</script>
